export const SUCCESS_MESSAGE_RESET = 'New password has been created!';
export const ERROR_INVALID_TOKEN = 'Your session to reset your password has expired. Please, click “Forgot password”';
export const PDF_DOWNLOAD = 'Please wait. Pdf is loading';